export default class FilePreviewModal {
	/* @ngInject */
	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 */
	constructor(
		kid,
		$uibModalInstance,
	) {
		this.kid = kid;
		this.$uibModalInstance = $uibModalInstance;
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}
}
